import Block from './Block'
import gsap from 'gsap'
import store from '../util/store'

export default class StepsHorizontal extends Block {
  getElems() {
    this.content = this.el.querySelector('.b-steps-horizontal__content')
    this.contentLinks = Array.from(this.el.querySelectorAll('.b-steps-horizontal__content__links a'))
    this.contentImages = Array.from(this.el.querySelectorAll('.b-steps-horizontal__content__images .image'))
    this.steps = Array.from(this.el.querySelectorAll('.b-steps-horizontal__steps__step'))
  }

  init() {
    if (store.detect.isMobile || store.w.w < 1200) return

    this._tlContent()
    this._tlSteps()
  }

  _tlContent() {
    gsap.set(this.content, {
      xPercent: 100
    })

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        scrub: true,
        start: 'top bottom',
        end: 'top top'
      }
    })

    tl.to(this.content, {
      xPercent: 0
    })
  }

  _tlSteps() {
    const count = this.steps.length

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        scrub: true,
        start: 'top top',
        end: '+=300%',
        pin: true,
        pinSpacing: true
      }
    })

    tl.to(this.el, {
      xPercent: - (100 / (count + 1)) * count
    })

    this.steps.forEach((step) => {
      const inner = step.querySelector('.image__inner')

      gsap.set(inner, {
        width: '120%',
        left: '-20%'
      })

      tl.to(inner, {
        left: '0%'
      }, '<')
    })
  }

  events() {
    if (store.detect.isMobile || store.w.w < 1200) return

    if (this.contentLinks) {
      this.contentLinks.forEach((link, indexLink) => {
        link.addEventListener('mouseenter', () => {
          this.contentImages.forEach((image, indexImage) => {
            if (indexImage === indexLink) {
              image.style.opacity = 1
            } else {
              image.style.opacity = 0
            }
          })
        })
      })
    }
  }
}
